import CentreFacilitiesNearYou from "./centreFacilitiesNearYou";
const CityFacilitiesNearYou = ({ row }) => {
    return (
        <div className="bg-white md:p-3 p-2">
            <p className="md:text-base text-sm font-bold md:mb-3 mb-2">
                {row.city}
            </p>
            {row?.centres?.map((item, index) => (
                <CentreFacilitiesNearYou key={index} item={item} />
            ))}
        </div>
    );
};
export default CityFacilitiesNearYou;
